import EventEmitter from 'events';
import axios from 'axios';
import qs from 'querystring';
import commonFunc from '@/common/commonFunction';
import apiConfig from '@/api/apiConfig';
import Utility from '@/common/utility';
import router from '@/router';
import store from '@/store/store';
import { MSEnum } from '@/common/enumeration';
import { removeStorage } from '@/store/vuex-persistance-plugin';
import { isNullOrEmpty } from '@/common/objectUtil';
import {
	ModuleAuth,
	ModuleDictionary,
	ModuleTaxPayerInfo,
	ModuleLicenseInfo,
	ModuleOrganization,
	ModuleUser
} from '../store/module-const';
import authAPI from '@/api/authAPI';
import eventBus from '../common/eventBus';
import { destroyMisaNotification } from '@/integrations/misaNotification';

// 'loggedIn' is used in other parts of application. So, Don't forget to change there also
const loginEventKey = 'loginEvent';
const userInfo = 'userInfo';

class AuthService extends EventEmitter {
	constructor() {
		super();
		axios.interceptors.response.use(
			response => {
				return response;
			},
			error => {
				//Status403Forbidden
				if (error && error.response && error.response.status == MSEnum.StatusCode.Status403Forbidden) {
					if (error.response.data.Code == MSEnum.AppCode.Status06NotPermittedAccess) {
						//router.push('/login/startwithtaxcode');
					} else if (error.response.data.Code == MSEnum.AppCode.Status11InvalidAdminAccess) {
						//router.push('/pages/not-permission');
					}
				}
				//Status401Unauthorized
				else if (error && error.response && error.response.status == MSEnum.StatusCode.Status401Unauthorized) {
					this.logOut();
				}
				//Status422UnprocessableEntity
				else if (
					error &&
					error.response &&
					error.response.status == MSEnum.StatusCode.Status422UnprocessableEntity
				) {
					//Nếu là lỗi nghiệp vụ thì hiển thị lỗi cho người dùng
					if (error.response.data && error.response.data.IsErrorBusiness) {
						return error.response.data;
					} else {
						this.logOut();
					}
				} else if (error && error.response) {
					return error.response;
				} else {
					return Promise.reject(error);
				}
			}
		);

		//Lắng nghe sự kiện hết hạn JWT
		this.onExpiredJwt = async data => {
			//Nếu là sự kiện hết hạn JWT thì đăng xuất
			this.logOut();
		};
		eventBus.on('onExpiredJwt', this.onExpiredJwt);
	}

	//Logout MISAID router sau khi logout
	logoutExternal() {
		//Lấy AccessToken để xử lý LogOut
		let auth = commonFunc.getJWTToken() || '';
		var urlLogout = window.location.origin + '/account/logout?jwtAuth=' + auth;
		window.location.href = urlLogout;
	}

	//Đăng xuất xóa phiên đăng nhập
	async logOut() {
		const me = this;
		//Hủy kết nối MISA Notification In-App trước khi logout
		destroyMisaNotification();
		//Gọi API đăng xuất
		await me.logOutApi();
		//Điều hướng về trang đăng nhập
		me.logoutExternal();
		//Xóa flag agreement check để lần đăng nhập sau hiển thị lại form
		sessionStorage.removeItem('agreement_checked');
		//Thực hiện xóa dữ liệu trong LocalStorage khi logout hoặc làm mới dữ liệu
		commonFunc.removeLocalStorage();
		//Xóa dữ liệu trong Vuex.Store
		await removeStorage();
	}

	async logOutApi() {
		try {
			let auth = commonFunc.getJWTToken() || '';
			await store.dispatch(`${ModuleUser}/logout`, { JwtAuth: auth });
		} catch (ex) {
			console.log(ex);
		}
	}

	//Kiểm tra xem còn session đăng nhập ko
	isAuthenticated() {
		let auth = commonFunc.getJWTToken();
		let expired = commonFunc.getExpiredAt();
		if (auth && expired) {
			//Lấy ngày hiện tại của máy chủ
			var currentDate = store.getters['licenseinfo/CurrentDate'];
			let isLogedin = auth && new Date(currentDate).getTime() < new Date(expired).getTime();
			return isLogedin;
		} else {
			return false;
		}
	}

	//Xử lý khi nhận kết quả auth từ MISAID
	//CreatedBy: qvliem - 19/11/2020
	handleAuthentication() {
		let me = this,
			callbackUrl = '';
		return new Promise((resolve, reject) => {
			var err,
				hash = window.location.hash.substr(1);
			var result = hash.split('&').reduce(function(result, item) {
				var parts = item.split('=');
				result[parts[0]] = parts[1];
				return result;
			}, {});
			//Thành công
			if (!result.error) {
				if (result['access_token']) {
					//Gọi lên server để lấy access_token của InBo
					me.postAuthAPI(result['access_token']).then(async res => {
						let data = res.data;

						if (data['Success']) {
							let code = data['ErrorCode'],
								payload = data['Data'];
							//không có quyền truy cập
							if (code == 403) {
								reject('');
							}

							//Nếu chỉ là smetoken thực hiện locallogin luôn
							let mToken = payload['AccessToken'];
							let tokenType = payload['TokenType'];
							let expireIn = payload['ExpiresIn'];
							let userInfo = payload['User'];

							var tokenInfo = {
								AccessToken: mToken,
								TokenType: tokenType,
								ExpiresIn: expireIn
							};

							if (mToken) {
								store.commit(`${ModuleAuth}/updateAccessToken`, tokenInfo);
								store.commit(`${ModuleAuth}/updateUserInfo`, userInfo);
							}

							//Trả kết quả
							resolve(payload);
						} else {
							reject('Đăng nhập thất bại. Chi tiết: ' + data['Message']);
						}
					});
				} else {
					reject('Đăng nhập thất bại. Vui lòng thử lại sau.');
				}
			} else {
				reject('Đăng nhập thất bại. Vui lòng thử lại sau.');
			}
		});
	}

	//Gọi api để đăng nhập thông qua token MISA ID
	//Created by qvliem - 26/11/2020
	postAuthAPI(accessToken) {
		let param = qs.stringify({ token: accessToken });
		return axios.post(authAPI.getAPIUrl() + '/login', param, undefined);
	}

	dispose() {
		const me = this;
		eventBus.off('onExpiredJwt', me.onExpiredJwt);
	}
}

export default new AuthService();
